var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPinIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 29,
    viewBox: "0 0 22 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 20.25C19 17.9063 17.6423 15.8386 15.5714 14.592V6.45H16.1429C16.5975 6.45 17.0335 6.26826 17.355 5.94476C17.6765 5.62126 17.8571 5.1825 17.8571 4.725C17.8571 4.2675 17.6765 3.82874 17.355 3.50524C17.0335 3.18174 16.5975 3 16.1429 3H5.85714C5.40249 3 4.96645 3.18174 4.64496 3.50524C4.32347 3.82874 4.14286 4.2675 4.14286 4.725C4.14286 5.1825 4.32347 5.62126 4.64496 5.94476C4.96645 6.26826 5.40249 6.45 5.85714 6.45H6.42857V14.592C4.35771 15.8386 3 17.9063 3 20.25H9.85714V24.85C9.85714 25.4825 10.3714 26 11 26C11.6286 26 12.1429 25.4825 12.1429 24.85V20.25H19Z",
    stroke: "#AD4D34",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinIcon);
export default __webpack_public_path__ + "static/media/pinIcon.f06b593f0517ae427f139480107f8a8a.svg";
export { ForwardRef as ReactComponent };